import { render, staticRenderFns } from "./bankCard.vue?vue&type=template&id=7b6f5bf2&scoped=true"
import script from "./bankCard.vue?vue&type=script&lang=js"
export * from "./bankCard.vue?vue&type=script&lang=js"
import style0 from "./bankCard.vue?vue&type=style&index=0&id=7b6f5bf2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f5bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6f5bf2')) {
      api.createRecord('7b6f5bf2', component.options)
    } else {
      api.reload('7b6f5bf2', component.options)
    }
    module.hot.accept("./bankCard.vue?vue&type=template&id=7b6f5bf2&scoped=true", function () {
      api.rerender('7b6f5bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/components/bankCard.vue"
export default component.exports